import { ETLDispatcher } from 'lib/ETLDispatcher';
import { EventData } from 'lib/EventTracking';

export class EventsDispatcher extends ETLDispatcher<EventData> {
  getEndpoint(): string {
    return '/v1/import';
  }

  requestPayload(events: EventData[]): { [key: string]: any } {
    return {
      batch: events,
      properties: this.sessionProperties,
    };
  }

  log(item: EventData) {
    const tag = 'event_key' in item.properties ? item.properties.event_key : item.event;
    console.groupCollapsed(`%c⚡️ EVT - ${tag}`, 'color: #962857');
    console.log(item.properties);
    console.log({ batch_properties: this.sessionProperties });
    console.groupEnd();
  }
}
